import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { LeftNavigation } from './LeftNavigation';
import { useNavigationStore } from '@/stores/navigation';
import { cn } from '@/lib/utils';

export function AppShell() {
  const { isNavCollapsed } = useNavigationStore();

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <div className="flex">
        <LeftNavigation />
        
        {/* Main Content Area */}
        <main 
          className={cn(
            "flex-1 transition-all duration-300 ease-in-out bg-white dark:bg-background",
            // Desktop: account for nav width
            "lg:ml-64",
            // Mobile: full width; only shift when large screens
            "ml-0",
            // Ensure main fills viewport height minus header, with mobile-friendly dvh
            "min-h-[calc(100dvh-4rem)]"
          )}
        >
          <div className="max-w-5xl px-4 sm:px-6 lg:px-10 py-9 pb-[max(2.25rem,env(safe-area-inset-bottom))]">
            <Outlet />
          </div>
        </main>
      </div>
      
      {/* Mobile nav overlay */}
      {!isNavCollapsed && (
        <div 
          className="fixed inset-0 bg-black/20 z-30 lg:hidden"
          onClick={() => useNavigationStore.getState().setNavCollapsed(true)}
        />
      )}
    </div>
  );
}